import { useEffect } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import Portal from '@app.components/Portal'

export interface IFBottomSheetProps {
  open?: boolean
  onClose?: () => void
}

const BottomSheet: React.FC<IFBottomSheetProps> = ({
  children,
  open = false,
  onClose,
}) => {
  useEffect(() => {
    if (!open) return
    if (typeof document !== 'object') return
    document.body.style.cssText = `
        overflow: hidden;
      `
    return () => {
      document.body.style.cssText = `
      `
    }
  }, [open])

  return (
    <Portal>
      <StyledWrapper className={`${open ? `open` : ``}`} onClick={onClose}>
        <div className="dimmed"> </div>
        <div className={`wrapper`} onClick={(e) => e.stopPropagation()}>
          <div className="header">
            <div className="close-btn"> </div>
          </div>
          {children}
        </div>
      </StyledWrapper>
    </Portal>
  )
}

export default BottomSheet

const StyledWrapper = styled.div`
  .dimmed {
    position: fixed;
    opacity: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 0.15s ease-out;
    z-index: 500;
  }
  .wrapper {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: white;
    transform: translateY(100%);
    transition: transform 0.15s ease-out;
    z-index: 500;
  }
  &.open {
    .dimmed {
      opacity: 1;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
    }
    .wrapper {
      transform: translateY(0%);
    }
  }
`
